import { render, staticRenderFns } from "./ActiveSiteTemplateNavbar.vue?vue&type=template&id=63a32804&"
import script from "./ActiveSiteTemplateNavbar.vue?vue&type=script&lang=js&"
export * from "./ActiveSiteTemplateNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSiteTemplateNavbar.vue?vue&type=style&index=0&id=63a32804&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports